import cx from 'clsx';
import React from 'react';

interface IProps {
  children: React.ReactNode;
  className: string;
}

const Card: React.FC<IProps> = ({ children, className }) => {
  return (
    <div
      className={cx(
        'rounded-xl border border-[#F1F0F6]  p-6 bg-pure-white',
        className
      )}
    >
      {children}
    </div>
  );
};
export default React.memo(Card);
